module.exports=function(scope){ return `{
    "meta": {
        "ok": true,
        "code": 200
    },
    "data": {
        "sessionToken": "..."
    }
}
`};


// WEBPACK FOOTER //
// ./src/resources/code/restsdk-v2/response/success/session-token.json.tpl